import { isIOS } from 'react-device-detect'

type Platforms = 'android' | 'ios'

const urls: Record<Platforms, Record<string, string>> = {
  android: {
    nl: 'https://play.google.com/store/apps/details?id=com.dhlparcel.nl',
  },
  ios: {
    nl: 'https://apps.apple.com/nl/app/mijn-dhl/id1530944632',
  },
}

export const getAppStoreUrl = (tld: string): string | undefined => {
  const platform = isIOS ? 'ios' : 'android'
  return urls[platform][tld]
}
